export const checkIsFreeArticle = function (article) {
    if (article.hasOwnProperty('is_premium') && article.hasOwnProperty('premium_type')) {
        if (article.is_premium === true && article.premium_type === 2) {
            return false;
        }
    }
    return true;
};